import { Alert, AlertTitle } from '@folio/components';
import { QuoteContext } from '@folio/modules/shared-quote/QuoteContext';
import { parseWakamError } from '@folio/utils/parseWakamError';
import { type QuoteError, quoteFailedUserHelp } from '@folio/utils/quoteFailedHelp';
import { AlertOctagonIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useContext } from 'react';

export function QuoteWakamError() {
  const { t } = useTranslation();
  const { calculatedQuotes } = useContext(QuoteContext);

  const details = calculatedQuotes.find(quote => quote.error)?.error?.details as
    | { quoteErrors?: QuoteError[]; failedReason?: string; errorMessage?: string }
    | undefined;

  const wakamError = details?.quoteErrors?.length
    ? quoteFailedUserHelp(details.quoteErrors)
    : parseWakamError(details?.failedReason ?? details?.errorMessage);

  if (!wakamError) {
    return null;
  }

  return (
    <Alert variant="destructive" className="flex justify-between items-center">
      <div>
        <AlertTitle className="flex items-center gap-4 pt-1">
          <AlertOctagonIcon />
          {t('errors.wakamPricingError')}
        </AlertTitle>
        <div className="mt-2">
          <p className="text-sm">{wakamError.replace('Seule', 'Seul')}</p>
        </div>
      </div>
    </Alert>
  );
}
